import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"16.5\" cy=\"3.5\" r=\"2\" stroke=\"currentColor\" stroke-width=\"1.5\"></circle><circle cx=\"16.5\" cy=\"15.5\" r=\"2\" stroke=\"currentColor\" stroke-width=\"1.5\"></circle><circle cx=\"4.5\" cy=\"3.5\" r=\"2\" stroke=\"currentColor\" stroke-width=\"1.5\"></circle><path d=\"M8.5 11.5L15 5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4.5 10.5V5.5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.5 15.5H14.5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><circle cx=\"5.5\" cy=\"14.5\" r=\"4\" stroke=\"currentColor\" stroke-width=\"1.5\"></circle>", 7)
  ]))]))
}
export default { render: render }